import { useState, useRef, useEffect } from 'react';

const ShowOrders = () => {
    const [showModal, setShowModal] = useState(false);
    const startCoords = useRef({ x: 0, y: 0 });
    const isMobile = useRef(false);
    const threshold = 100; // Swipe distance threshold

    const selectedItemData = JSON.parse(localStorage.getItem("selectedItems"))
  console.log("order", selectedItemData);
    useEffect(() => {
      isMobile.current = window.innerWidth <= 768; // Mobile screen width
    }, []);
  
    const handleTouchStart = (e) => {
      if (!isMobile.current) return;
      const touch = e.touches[0];
      startCoords.current = { x: touch.clientX, y: touch.clientY };
    };
  
    const handleTouchMove = (e) => {
      if (!isMobile.current) return;
  
      const touch = e.touches[0];
      const deltaX = touch.clientX - startCoords.current.x;
      const deltaY = touch.clientY - startCoords.current.y;
  
      // Calculate absolute swipe distance in any direction
      if (Math.abs(deltaX) > threshold || Math.abs(deltaY) > threshold) {
        setShowModal(false);
      }
    };

  return (
    <>
      <button className="btn btn-primary showbtnCss"
        
       onClick={() => setShowModal(true)}
       >
       Show Orders
      </button>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div
            className="modal-container"
            // onClick={(e) => e.stopPropagation()}
            onClick={() => setShowModal(false)}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
          >
            {/* <div className="modal-header">
              <h3>Available Offers</h3>
              <button className="close-btn" onClick={() => setShowModal(false)}>
                ×
              </button>
            </div> */}
            <div className="modal-body">
                <table className='border w-100'>
                    <thead className='border'>
                        <tr className='border'>
                            <th className='border'>
                                Item Name
                            </th>
                            <th className='border text-right' >
                                Rate
                            </th>
                            <th className='border text-right'   >
                                Qty
                            </th>
                            <th className='border text-right'   >
                                Amount
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedItemData.map((item)=>(
                             <tr key={item.qrItemId} className='border'>
                             <td className='border'>
                                 {item.qrItemName}
                             </td>
                             <td className='border text-right'>
                             {item.ApplayRate}
                             </td>
                             <td className='border text-right'>
                             {item.Qty}
                             </td>
                             <td className='border text-right'>
                             {item.Amount}
                             </td>
                         </tr>

                        ))}
                   

                    </tbody>
                </table>
            </div>
          </div>
        </div>
      )}
    </>

  );
}

export default ShowOrders;
